<template>
  <div class="modal-content">
    <div class="modal-body">
      <payment-plan-details :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" :component="component" v-on:close="hideModal" v-on:save="save" />
    </div>
  </div>
</template>

<script>

import PaymentPlanDetails from '~/components/PaymentPlanDetails'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'component'],
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save (data) {
      this.$emit('save', data)
    }
  },
  components: {
    PaymentPlanDetails
  }
}

</script>